import { Save, X } from 'lucide-react';
import type { ReactNode } from 'react';
import { Button } from '@/shared/components/ui';
import { cn } from '@/shared/utils';

export type DetailPageActionConfig = {
  label: string;
  onClick: () => void;
  disabled?: boolean;
  loading?: boolean;
};

export type DetailPageActionsProps = {
  actions?: ReactNode;
  secondaryAction?: DetailPageActionConfig;
  primaryAction?: DetailPageActionConfig;
  className?: string;
};

export function DetailPageActions({
  actions,
  secondaryAction,
  primaryAction,
  className,
}: DetailPageActionsProps) {
  if (!actions && !secondaryAction && !primaryAction) {
    return null;
  }

  return (
    <div className={cn('flex items-center gap-3', className)}>
      {actions}
      {secondaryAction && (
        <Button
          aria-label={secondaryAction.label}
          variant="outline"
          onClick={secondaryAction.onClick}
          disabled={secondaryAction.disabled}
        >
          <span aria-hidden="true" className="mr-2 inline-flex">
            <X size={16} />
          </span>
          {secondaryAction.label}
        </Button>
      )}
      {primaryAction && (
        <Button
          aria-label={primaryAction.label}
          onClick={primaryAction.onClick}
          disabled={primaryAction.disabled || primaryAction.loading}
        >
          <span aria-hidden="true" className="mr-2 inline-flex">
            <Save size={16} />
          </span>
          {primaryAction.label}
        </Button>
      )}
    </div>
  );
}
